import { render } from "./fileP.vue?vue&type=template&id=0106a156"
import script from "./fileP.vue?vue&type=script&lang=js"
export * from "./fileP.vue?vue&type=script&lang=js"

import "./fileP.vue?vue&type=style&index=0&id=0106a156&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__